import { connect } from 'react-redux'
import { findCinemaId } from '../../../global/helpers'

const mapStateToProps = (state) => {
    const cinemaid = findCinemaId(state)

    return {
        cinemaid,
        formOpen: state?.components?.forms?.goPay?.open,
        cinemaSelectionRequired: state?.components?.cinemaSelect?.isOpen ?? false,
    }
}

const mapDispatchToProps = {}

const hocAppLayout = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocAppLayout
